import { UsageCard } from "@/components/insights/InsightsCardItem";
import { formatSeconds } from "@/format/time";
import { useActiveEnvironmentsCount, useActiveUsersCount, useEnvironmentRuntime } from "@/queries/insights-queries";
import type { TimeRange } from "@/routes/insights/insights";
import type { Timestamp } from "@bufbuild/protobuf";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import type { FC } from "react";

type Props = {
    startTimestamp: Timestamp;
    endTimestamp: Timestamp;
    selectedRange: TimeRange;
    projectId?: string;
};
export const InsightCards: FC<Props> = ({ startTimestamp, endTimestamp, selectedRange, projectId }) => {
    const { data: activeUsersCount, isLoading: isLoadingUsers } = useActiveUsersCount(
        startTimestamp,
        endTimestamp,
        selectedRange,
        projectId,
    );

    const { data: activeEnvironmentsCount, isLoading: isLoadingEnvironments } = useActiveEnvironmentsCount(
        startTimestamp,
        endTimestamp,
        selectedRange,
        projectId,
    );

    const { data: environmentRuntime, isLoading: isLoadingEnvironmentRuntime } = useEnvironmentRuntime(
        startTimestamp,
        endTimestamp,
        selectedRange,
        projectId,
    );

    return (
        <TabsPrimitive.List className="flex flex-wrap gap-4">
            <UsageCard
                title="Active users"
                value={
                    isLoadingUsers
                        ? "Loading..."
                        : `${activeUsersCount?.count !== undefined ? Number(activeUsersCount.count).toLocaleString() : "n/a"}`
                }
                trend={activeUsersCount?.trend ?? 0}
                isLoading={isLoadingUsers}
                targetView="activeUsers"
            />
            <UsageCard
                title="Environments"
                value={`${activeEnvironmentsCount?.count !== undefined ? Number(activeEnvironmentsCount.count).toLocaleString() : "n/a"}`}
                trend={activeEnvironmentsCount?.trend ?? 0}
                isLoading={isLoadingEnvironments}
                targetView="activeEnvironments"
            />
            <UsageCard
                title="Total time"
                value={
                    isLoadingEnvironmentRuntime
                        ? "Loading..."
                        : `${
                              environmentRuntime?.totalRuntimeSeconds !== undefined
                                  ? formatSeconds(Number(environmentRuntime.totalRuntimeSeconds))
                                  : "n/a"
                          }`
                }
                trend={environmentRuntime?.trend ?? 0}
                isLoading={isLoadingEnvironmentRuntime}
                targetView="environmentRuntime"
            />
        </TabsPrimitive.List>
    );
};
